import * as React from 'react';
import { useEffect, useRef } from 'react';
import { observer } from '../utils/Common';

export interface ISkillProps {
}


export function Skill(props: ISkillProps) {
    const progressBarRef = useRef<HTMLDivElement>(null);
    const progressBarRef1 = useRef<HTMLDivElement>(null);
    const progressBarRef2 = useRef<HTMLDivElement>(null);
    const progressBarRef3 = useRef<HTMLDivElement>(null);
    const progressBarRef4 = useRef<HTMLDivElement>(null);
    const progressBarRef5 = useRef<HTMLDivElement>(null);
    const progressBarRef6 = useRef<HTMLDivElement>(null);



    useEffect(() => {
        const elRefs = [
            progressBarRef.current,
            progressBarRef1.current,
            progressBarRef2.current,
            progressBarRef3.current,
            progressBarRef4.current,
            progressBarRef5.current,
            progressBarRef6.current
        ];
    
        elRefs.forEach(el => {
            if (el) observer.observe(el);
        });
    
        return () => {
            elRefs.forEach(el => {
                if (el) observer.unobserve(el);
            });
        };
    }, []);
    
    

    return (
        <section className="skill-section">
            <div className="skill-container">
                <h2 className="skill-title">My Skills Values</h2>
                <div className="skills-row">
                    <div className="skill-column technical-skills">
                        <h4>Technical Skills</h4>
                        <label className="progress-bar-label">Java</label>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" ref={progressBarRef} aria-valuenow={95} style={{ width: "0%" }}>
                                <span>95%</span>
                            </div>
                        </div>
                        <label className="progress-bar-label">Spring Boot & Spring MVC</label>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" ref={progressBarRef1} aria-valuenow={95} style={{ width: '0%' }}>
                                <span>95%</span>
                            </div>
                        </div>
                        <label className="progress-bar-label">React JS</label>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" ref={progressBarRef2} aria-valuenow={85} style={{ width: '0%' }}>
                                <span>85%</span>
                            </div>
                        </div>
                        <label className="progress-bar-label">Javascript</label>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" ref={progressBarRef3} aria-valuenow={85} style={{ width: '0%' }}>
                                <span>85%</span>
                            </div>
                        </div>
                        <label className="progress-bar-label">Azure</label>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" ref={progressBarRef4} aria-valuenow={93} style={{ width: '0%' }}>
                                <span>93%</span>
                            </div>
                        </div>
                        <label className="progress-bar-label">Docker</label>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" ref={progressBarRef5} aria-valuenow={95} style={{ width: '0%' }}>
                                <span>95%</span>
                            </div>
                        </div>
                        <label className="progress-bar-label">Kubernetes</label>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" ref={progressBarRef6} aria-valuenow={90} style={{ width: '0%' }}>
                                <span>90%</span>
                            </div>
                        </div>
                    </div>
                    <div className="skill-column knowledge-skills">
                        <h4>Knowledge</h4>
                        <div className="knowledge-grid">
                            <div className="knowledge-column">
                                <ul className="list-icons purple bold-list">
                                    <li><i className="md-arrow-forward"></i>Spring Boot & Spring MVC</li>
                                    <li><i className="md-arrow-forward"></i>Hibernate</li>
                                    <li><i className="md-arrow-forward"></i>JPA</li>
                                    <li><i className="md-arrow-forward"></i>Junit & Mockito</li>
                                    <li><i className="md-arrow-forward"></i>Docker & Kunernetes</li>
                                    <li><i className="md-arrow-forward"></i>ReactJS</li>
                                    <li><i className="md-arrow-forward"></i>JavaScript & TypeScript</li>
                                </ul>
                            </div>
                            <div className="knowledge-column">
                                <ul className="list-icons purple bold-list">
                                    <li><i className="md-arrow-forward"></i>SQL Database</li>
                                    <li><i className="md-arrow-forward"></i>MicroService</li>
                                    <li><i className="md-arrow-forward"></i>Azure & Aws</li>
                                    <li><i className="md-arrow-forward"></i>Github Workflow</li>
                                    <li><i className="md-arrow-forward"></i>Terraform</li>
                                    <li><i className="md-arrow-forward"></i>Grafana & Splunk</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
